import script from "./GruposListaEsperaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GruposListaEsperaModal.vue?vue&type=script&setup=true&lang=js"

import "./GruposListaEsperaModal.vue?vue&type=style&index=0&id=b10ebf5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b10ebf5e"]])

export default __exports__